import { render, staticRenderFns } from "./DataDictSelect.vue?vue&type=template&id=067bb078"
import script from "./DataDictSelect.vue?vue&type=script&lang=js"
export * from "./DataDictSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports